module.exports = __webpack_public_path__ + "img/yellow-star-icon.1f109ee6.svg";